import http from "../../utils/http_client";

const getFeedbacks = async (feedbackUrl: string, filters: object) => {
  return await http.getJson(feedbackUrl, filters);
};

const putFeedbacks = async (feedbackUrl: string, feedbacks: object) => {
  return await http.putJson(feedbackUrl, feedbacks);
};

export default {
  getFeedbacks,
  putFeedbacks
};
